export default {"src":"/_next/static/media/scrollUpBtn.55774342.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};